import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar to handle the images rotation workflow.
*/
@Component({
	selector: 'rotation-workflow',
	templateUrl: './rotation-workflow.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class RotationWorkflowComponent extends BaseComponent {

	isImgVisible = false;
	readonly helpImg = 'images/gif/rotate.gif';

	/**
	* Confirm rotation.
	*/
	confirm(): void {
		this.canvasSrv.dispatch('confirmRotate');
	}

}
